import React from "react";
import classNames from "classnames";
import "./IconButton.css";

export interface IconButtonProps
  extends Omit<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    "children" | "onClick"
  > {
  iconClassName: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  "aria-label": string;
}

const IconButton: React.FC<IconButtonProps> = ({
  iconClassName,
  onClick,
  type = "button",
  className,
  ...buttonProps
}) => (
  <button
    {...buttonProps}
    type={type}
    className={classNames("btn icon-button p-0 border-0", className)}
    onClick={onClick}
  >
    <i className={iconClassName} aria-hidden="true"></i>
  </button>
);

export default IconButton;
